aggregatedUpstreamContext